//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ElLink from '@/components/UI/el-link'
import AButton from './components/button/button.vue'

export default {
  name: 'SummerSection',
  components: { AButton, ElLink },
  data() {
    return {
      isDesktop: null,
    }
  },
  mounted() {
    this.windowSizeHandler()
    window.addEventListener('resize', this.windowSizeHandler, { passive: true })
  },
  methods: {
    getUrl() {
      return this.$getTextSetting('summerIntensiveButtonUrl', '/camp')
    },
    changeRoute() {
      const route = this.getUrl()

      window.location.href = this.localePath(route, this.$i18n.locale)
    },
    windowSizeHandler() {
      this.isDesktop = window.innerWidth <= 960
    },
  },
}
